module.exports = __webpack_public_path__ + "img/mobilis_logo.7e7ea067.png";